import React from "react";
import { withRouter, Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Fade from 'react-reveal/Fade';
import {Helmet} from "react-helmet";

import aim from "../../assets/aim.png"
import location from "../../assets/location.png"
import time from "../../assets/time.png"
import "./about.css";
import Footer from "../../components/Footer/footer";


const tabStyle = {
    row: {
        marginLeft: 0,
        marginRight: 0
    },
    col: {
        paddingLeft: 0,
        paddingRight: 0
    }
};
  

class about extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectView: true,
      targetView: false,
      deliverableView: false,
      aboutView: false
      
    };
  }
  componentDidMount(){
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }
  render() {
    return (
      <div>
        <Helmet>
            <html lang="en" />  
            <meta charSet="utf-8" />
            <title>NIELIT Kohima - Digital Intervention of Handloom and Handicraft | About</title>
            <meta name="description" content="The project 'Digital Intervention of Handicraft & Handloom' was commenced in the year 2021. Trainings for each of the sector are organised on monthly basis, which empowers the handicraft and handloom in the state of Nagaland as a pilot project initiated by the Ministry of Electronics and Information Technology, Govt. of India." />
            <link rel="canonical" href="https://nielitdihh.in/" />
        </Helmet>
        <div className="about_div_1">
          <div className="dashbaord_div_1_inner">
            <p className="dashbaord_div_1_inner_txt">Digital Intervention in Handicraft and Handloom</p>
            <p className="home_box_1_para_white">The project "Digital Intervention of Handicraft & Handloom" was commenced in the year 2021. Trainings for each of the sector are organised on monthly basis, which empowers the handicraft and handloom in the state of Nagaland as a pilot project initiated by the Ministry of Electronics and Information Technology, Govt. of India.</p>
            <button className="requestQuote">
              <a className="href_reports" href="#tabs">Know More</a>
            </button>
          </div>
        </div>
        <div className="about_tabs" id="tabs">
            <Row style={tabStyle.row}>
                <Col md={2} xs={6} sm={6}>
                    {
                        this.state.projectView ?
                            <div className="about_tabs_active">
                                <span className="about_tabs_active_txt">Project Info</span>
                            </div>
                        :
                        <div className="about_tabs_inactive" onClick={() => this.setState({projectView: true, targetView: false, deliverableView: false, aboutView: false})}>
                            <span className="about_tabs_inactive_txt">Project Info</span>
                        </div>
                    }
                </Col>
                <Col md={2} xs={6} sm={6}>
                    {
                        this.state.targetView ?
                            <div className="about_tabs_active">
                                <span className="about_tabs_active_txt">Targets</span>
                            </div>
                        :
                        <div className="about_tabs_inactive" onClick={() => this.setState({projectView: false, targetView: true, deliverableView: false, aboutView: false})}>
                            <span className="about_tabs_inactive_txt">Targets</span>
                        </div>
                    }
                </Col>
                <Col md={2} xs={6} sm={6}>
                    {
                        this.state.deliverableView ?
                            <div className="about_tabs_active">
                                <span className="about_tabs_active_txt">Deliverables</span>
                            </div>
                        :
                        <div className="about_tabs_inactive" onClick={() => this.setState({projectView: false, targetView: false, deliverableView: true, aboutView: false})}>
                            <span className="about_tabs_inactive_txt">Deliverables</span>
                        </div>
                    }
                </Col>
                <Col md={2} xs={6} sm={6}>
                    {
                        this.state.aboutView ?
                            <div className="about_tabs_active">
                                <span className="about_tabs_active_txt">About NIELIT</span>
                            </div>
                        :
                        <div className="about_tabs_inactive" onClick={() => this.setState({projectView: false, targetView: false, deliverableView: false, aboutView: true})}>
                            <span className="about_tabs_inactive_txt">About NIELIT</span>
                        </div>
                    }
                </Col>
                <Col></Col>
            </Row>
        </div>
        {
            this.state.targetView ?
                <div className="targets_View">
                    <table className="targetsTable">
                        <thead>
                            <tr>
                            <th>&nbsp;Sl. No</th>
                            <th>&nbsp;Training Programs</th>
                            <th>&nbsp;Targets</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>&nbsp;1</td>
                                <td className="boldText">&nbsp;Awareness Workshop</td>
                                <td>&nbsp;1000</td>
                            </tr>
                            <tr>
                                <td>&nbsp;2</td>
                                <td className="boldText">&nbsp;Digital Literacy (Basic of computers, internet usage and digital payments)</td>
                                <td>&nbsp;4000</td>
                            </tr>
                            <tr>
                                <td>&nbsp;3</td>
                                <td className="boldText">&nbsp;Digital Photography and Scanning</td>
                                <td>&nbsp;400</td>
                            </tr>
                            <tr>
                                <td>&nbsp;4</td>
                                <td className="boldText">&nbsp;CAD/CAM technology</td>
                                <td>&nbsp;200</td>
                            </tr>
                            <tr>
                                <td>&nbsp;5</td>
                                <td>
                                    <table className="paleBlueRows">
                                        <tbody>
                                            <tr>
                                                <td className="boldText">IT based Capacity building for different crafts</td>
                                            </tr>
                                            <tr>
                                                <td>a) Weaving</td>
                                                <td>300</td>
                                            </tr>
                                            <tr>
                                                <td>b) Dyeing &amp; Finishing</td>
                                                <td>40</td>
                                            </tr>
                                            <tr>
                                                <td>c) Training for Cane/bamboo/wood artisans</td>
                                                <td>200</td>
                                            </tr>
                                            <tr>
                                                <td>d) Design and product development</td>
                                                <td>200</td>
                                            </tr>
                                            <tr>
                                                <td>e) Software based Design/Motif development</td>
                                                <td>200</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <td>940</td>
                            </tr>
                            <tr>
                                <td>&nbsp;6</td>
                                <td>
                                    <table className="paleBlueRows2">
                                        <tbody>
                                            <tr>
                                                <td className="boldText">Entrepreneurship & Soft Skill development</td>
                                            </tr>
                                            <tr>
                                                <td>a) Marketing skills, branding, advertising, supply chain and logistics</td>
                                            </tr>
                                            <tr>
                                                <td>b) Quality checks & control measures</td>
                                            </tr>
                                            <tr>
                                                <td>c) Intellectual property Rights (Geographical Indication, Design Rights, Copyright, Trademark, etc)</td>
                                            </tr>
                                            <tr>
                                                <td>d) Packaging techniques for various types of products</td>
                                            </tr>
                                            <tr>
                                                <td>d) Packaging techniques for various types of products</td>
                                            </tr>
                                            <tr>
                                                <td>f) Online transaction and security.</td>
                                            </tr>
                                            <tr>
                                                <td>g) Soft Skill: customers service, leadership skills, effective communication, presentation skills, team work.</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <td>380</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;Total</td>
                                <td>&nbsp;6920</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            : 
                <></>
        }
        {
            this.state.projectView ?
                <div className="targets_View">
                    <Fade bottom>
                        <p className="about_para_title"><mark>Digital Intervention on Handicraft & Handloom Sector for Livelihood Enhancement of Artisans of NE States</mark></p>
                        <p className="about_para_subtitle">Digital NE Vision document 2022 Chapter No 3. Digital Empowerment Clause No. 5: Skill development and career opportunity proposed to take up initiatives in some of the centres to improve livelihood in the area of handloom, handicraft, textiles, tourism, horticulture, food processing and bamboo etc. through training programs in the use of relevant digital technologies.</p>
                        <hr/>
                        <div className="breaker"/>
                        <img src={aim} className="about_icons"></img>
                        <span className="about_para_header">Aim & Objectives</span>
                        <br clear="all" /><br/>
                        <p className="about_para_subtitle">The region holds unlimited potential for development in the area of handloom and handicraft abounds in resources that have the potential to render a progressive outlook. The handlooms and handcrafts products not just mirror the region's culture and tradition but also play a major role in employing a vast majority of artisans and crafts-persons.</p>
                        <p className="about_para_subtitle">Handloom and handicraft primarily thrive, yet there's much that can be done to lessen the day to day rigours in the lives of people of the North East and to impart economic stability to them.</p>
                    </Fade>
                    <ul>
                        <li>To setup Digital enabled Common Facility Centre at Nagaland for the handloom and handicraft artisans of NE States.</li>
                        <li>To make traditional artisans and rural entrepreneurs competitive and provide support for their long term sustainability and economy of scale</li>
                        <li>To enhance the marketability of cluster products by supporting new products, design intervention and improved packaging as well as improving marketing infrastructure</li>
                        <li>To tap e-commerce as a major marketing channel given the outreach and growing market penetration of e-commerce, there is a need to devise a quick strategy to make its presence felt in the e-retail space by the development of an e-commerce platform for marketing the handloom and handicraft products</li>
                        <li>Development of e-contents and documentary film on Handloom & Handicraft Products preparation & procedural methodology for sharing the entire technical process flow/ technological intervention/all machine operation through the developed self-learning content with hands-on training</li>
                        <li>To equip traditional artisans of the associated clusters with improved skills and capabilities through training</li>
                        <li>To reinforce cluster governance systems with active stakeholder participation, and make them able to gauge and react to rising challenges and opportunities coherently</li>
                        <li>To build up innovative and traditional skills, improved technologies, advanced processes, market intelligence and new models of public-private partnerships, to gradually replicate similar models of cluster-based regenerated traditional industries.</li>
                        <li>To look for setting up of multi-product cluster with an integrated value chain and a strong market-driven approach for the viability and long term sustainability of the cluster</li>
                        <li>To ensure convergence from the design stage with each activity of the cluster formation and operations thereof.</li>
                        <li>Digital storing of simple local motifs and develop into artistic patterns for future references.</li>
                        <li>To identify and understand the cluster's target customers, their needs and aspirations and develop and present product lines to meet the requirement. The substantial focus should be on the buyer segment that places a premium on natural, eco-friendly, ethically sourced and the uniqueness of artisanal products.</li>
                        <li>To develop specific product lines out of the currently offered heterogeneous products based on the understanding of the target consumer group.</li>
                        <li>To make a substantial investment in product design and quality improvement. The quality of inputs and processes needs standardization so that the product meets quality standards. Research is essential to develop new textures and finishes to suit current market trends.</li>
                        <li>To make a paradigm shift from a supply-driven selling model to a market-driven model with the right branding, focus product mix and correct positioning and right pricing to make the offering holistic and optimal for each of the focus categories.</li>
                        <li>To make provision for common facilities and improved IT tools and equipment for artisans to promote optimum utilization of infrastructure facilities</li>
                    </ul>
                    <div className="breaker"/>
                    <hr/>
                    <div className="breaker"/>
                    <Fade bottom>
                        <img src={location} className="about_icons"></img>
                        <span className="about_para_header">Location of the project</span>
                        <br clear="all" /><br/>
                        <p className="about_para_subtitle">The initial phase of this project will be acting as a pilot project at the district level inside Nagaland. After the successful completion of the pilot project, further enhancement will be extended to all Northeastern States.</p>
                        <hr/>
                        <div className="breaker"/>
                        <img src={time} className="about_icons"></img>
                        <span className="about_para_header">Duration of the project</span>
                        <br clear="all" /><br/>
                        <p className="about_para_subtitle">The tenure of the Pilot Project will be 3 Yrs as per the project proposal.</p>
                    </Fade>
                </div>
            :
                <></>
        }
        {
            this.state.deliverableView ? 
                <div className="targets_View">
                    <p className="about_para_header_default">Deliverables under the project</p>
                    <br clear="all" /><br/>
                    <Fade bottom cascade>
                        <ul>
                            <li>Setup Digital enabled Common Facility Centre at NIELIT Kohima Nagaland for the handloom and handicraft artisans of NE States.</li>
                            <li>Awareness workshop for 1000 artisans on design development, product development and e-marketing of handloom and handicraft.</li>
                            <li>Training of 5920 tribal youths and women practising either handloom or handicrafts from Nagaland in Digital enabled courses. Out of which 380 as Trainers/Entrepreneurs.</li>
                            <li>Modernization & Modification of Handloom & Handicraft Products using IT and IT based machineries and promoting the products globally by Dynamic Web Portal with e-commerce facilities & Mobile banking for worldwide marketability</li>
                            <li>Envisages to conduct Entrepreneurship Development Programme for intensive training on Capacity Building, backward-forward linkages and handholding support with Banking organization like NABARD and with CSR activities of reputed organisation</li>
                            <li>Development of e-content and documentary film on Handloom & Handicraft Products preparation & procedural methodology for sharing the entire technical process flow/ technological intervention/all machine operation through the developed self-learning content with hands-on training.</li>
                        </ul>
                    </Fade>
                </div>
            :
                <></>
        }
        {
            this.state.aboutView ? 
                <div className="targets_View">
                    <p className="about_para_header_default">About NIELIT Kohima</p>
                    <br clear="all" /><br/>
                    <Fade bottom cascade>
                        <div>
                            <p className="about_para_subtitle">National Institute of Electronics & Information Technology (NIELIT), Kohima with its stately architecture surrounded by lush verdant and picturesque rolling hills has world-class infrastructure that facilitates excellence in IECT-related teaching, training and other professional activities, besides involving in Research & Development work, Consultancy services and Software Development. It is a national level technical Institute under NIELIT, an autonomous scientific body of the Ministry of Communications & IT, Govt. of India set up in the year 2004.</p>
                            <p className="about_para_subtitle">NIELIT Kohima also aspires to be a hub of innovative activity and is continuously on the lookout for opportunities to collaborate with organisations in government, the public and private sectors and other academic institutions to create, disseminate and apply computer knowledge and practices. NIELIT as an institute offers training program to improve employment opportunities and facilitate availability of quality IT manpower, which will contribute to the growth of IT industry in the region particularly in Nagaland. A special feature of NIELIT is the provision of a balanced amalgamation of formal and non-formal sector courses with the aim to provide opportunities for education and training in the field of IECT.</p>
                        </div>
                    </Fade>
                </div>
            :
                <></>
        }
        <Footer/>
      </div>
    )
  }
}
export default withRouter(about);